<template>

<div>
    <competition v-if='page == "competition"'></competition>
    <auction v-if='page == "auction"'></auction>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                page : 'competition'
            }
        },

        methods : {

        },

        components : {
            'competition' : require('./Competition.vue').default,
            'auction'     : require('./Auction.vue').default,
        } 
    }
</script>
